<div style="display: flex; flex-direction: column; justify-content: center; align-items: center; " *ngIf="isLoading">
  <nz-spin nzSimple nzSize="large"></nz-spin>
  <p style="margin-top: 10px;">Please wait, loading data...</p>
</div>

<div style="text-align: center; margin-bottom: 10px;" *ngIf="!isLoading && (isShortlisted || isFinalized)">
  This Submission is
  <nz-tag [nzColor]="'green'" *ngIf="isShortlisted">Shortlised</nz-tag>
  <span *ngIf="isShortlisted && isFinalized">&</span>
  <nz-tag [nzColor]="'green'" *ngIf="isFinalized">Finalized</nz-tag>
</div>

<div class="submission-qa-container" *ngIf="!isLoading">
  <ng-container *ngFor="let section of sectionsData; let sIndex = index">
    <nz-collapse class="mb-4">
      <nz-collapse-panel [nzHeader]="sectionHeaderTemplate" [nzActive]="sIndex === 0">
        <ng-template #sectionHeaderTemplate>
          <h4>{{section?.section_title}}</h4>
        </ng-template>
        <h5 style="margin-bottom: 20px; color: grey; font-style: italic;">{{section?.description}}</h5>
        <nz-descriptions [nzTitle]="null" nzBordered [nzColumn]="1">
          <nz-descriptions-item [nzTitle]="question.question_text"
            *ngFor="let question of section.questions; let qIndex = index">
            
            <!-- NEW: EDIT MODE OR VIEW MODE -->
            <ng-container *ngIf="getAnswerForQuestion(question.id) as answer">
              
              <!-- NEW: VIEW MODE (Default display with edit icon) -->
              <ng-container *ngIf="editingQuestionId !== question.id">
                <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                  <div style="flex: 1;">
                    <ng-container [ngSwitch]="question.question_type">
                      <!-- OLD: <span *ngSwitchCase="'TEXT_SHORT'">{{ answer.answer_text_short }}</span> -->
                      <span *ngSwitchCase="'TEXT_SHORT'">{{ answer.answer_text_short }}</span>
                      
                      <!-- OLD: <span *ngSwitchCase="'TEXT_LONG'">{{ answer.answer_text_long }}</span> -->
                      <span *ngSwitchCase="'TEXT_LONG'">{{ answer.answer_text_long }}</span>
                      
                      <!-- OLD: <span *ngSwitchCase="'NUMBER'">{{ answer.answer_number }}</span> -->
                      <span *ngSwitchCase="'NUMBER'">{{ answer.answer_number }}</span>
                      
                      <!-- OLD: <span *ngSwitchCase="'CURRENCY'">{{ answer.answer_number | currency:'USD':'symbol':'1.2-2' }}</span> -->
                      <span *ngSwitchCase="'CURRENCY'">{{ answer.answer_number | currency:'USD':'symbol':'1.2-2' }}</span>
                      
                      <!-- OLD: <span *ngSwitchCase="'BOOLEAN_YES_NO'">{{ answer.answer_boolean ? 'Yes' : 'No' }}</span> -->
                      <span *ngSwitchCase="'BOOLEAN_YES_NO'">{{ answer.answer_boolean ? 'Yes' : 'No' }}</span>
                      
                      <!-- OLD: <span *ngSwitchCase="'DATE'">{{ answer.answer_date | date:'yyyy-MM-dd' }}</span> -->
                      <span *ngSwitchCase="'DATE'">{{ answer.answer_date | date:'yyyy-MM-dd' }}</span>
                      
                      <!-- OLD: FILE_UPLOAD (NOT EDITABLE) -->
                      <ng-container *ngSwitchCase="'FILE_UPLOAD'">
                        <div *ngIf="answer.answer_file_references && answer.answer_file_references.length > 0">
                          <p>Attached Files:</p>
                          <nz-list nzBordered nzHeader="" nzFooter="" class="file-list">
                            @for (fileRef of answer.answer_file_references; track fileRef) {
                            <nz-list-item>
                              <img nz-image width="60px" height="40px" [nzSrc]="fileRef.file_url" alt="" />
                              <a [href]="fileRef.file_url" target="_blank" download style="display:inline-block"> {{
                                fileRef.file_name }}</a>
                            </nz-list-item>
                            }
                          </nz-list>
                        </div>
                        <span *ngIf="!answer.answer_file_references || answer.answer_file_references.length === 0">No files
                          attached.</span>
                      </ng-container>
                      
                      <!-- OLD: MULTIPLE_FILES (NOT EDITABLE) -->
                      <ng-container *ngSwitchCase="'MULTIPLE_FILES'">
                        <div *ngIf="answer.answer_multiple_files && answer.answer_multiple_files.length > 0">
                          <p>Attached Files:</p>
                          <nz-list nzBordered nzHeader="" nzFooter="" class="file-list">
                            @for (fileRef of answer.answer_multiple_files; track fileRef) {
                            <nz-list-item>
                              <img nz-image width="60px" height="40px" [nzSrc]="fileRef.file_url" alt="" />
                              <a [href]="fileRef.file_url" target="_blank" download style="display:inline-block"> {{
                                fileRef.file_name }}</a>
                            </nz-list-item>
                            }
                          </nz-list>
                        </div>
                        <span *ngIf="!answer.answer_multiple_files || answer.answer_multiple_files.length === 0">No files
                          attached.</span>
                      </ng-container>

                      <!-- OLD: <span *ngSwitchCase="'MULTIPLE_CHOICE_SINGLE'">{{ answer.answer_selected_choice_ids }}</span> -->
                      <span *ngSwitchCase="'MULTIPLE_CHOICE_SINGLE'">
                        {{ answer.answer_selected_choice_ids }}
                      </span>

                      <!-- OLD: <ul *ngSwitchCase="'MULTIPLE_CHOICE_MULTI'" style="..."> -->
                      <ul *ngSwitchCase="'MULTIPLE_CHOICE_MULTI'"
                        style="margin-left:0px;padding-left:0px;list-style-type: none;">
                        <li *ngFor="let choiceId of answer.answer_selected_choice_ids">
                          {{ choiceId }}
                        </li>
                      </ul>

                      <!-- OLD: <span *ngSwitchCase="'DROPDOWN'">{{ answer.answer_text_short }}</span> -->
                      <span *ngSwitchCase="'DROPDOWN'">{{ answer.answer_text_short }}</span>

                      <!-- OLD: <div *nzDefault> -->
                      <div *nzDefault>
                        <p class="unsupported-type-message">Unsupported question type or no answer: {{ question.question_type
                          }}</p>
                      </div>
                    </ng-container>
                  </div>

                  <!-- NEW: EDIT ICON (Show only if answer is editable) -->
                  <div style="margin-left: 15px;">
                    <button nz-button nzType="text" nzSize="small" 
                      *ngIf="isAnswerEditable(question.question_type)"
                      (click)="startEdit(question.id, answer, question.question_type)"
                      title="Edit this answer">
                      <i nz-icon nzType="edit" nzTheme="outline"></i>
                    </button>
                  </div>
                </div>
              </ng-container>

              <!-- NEW: EDIT MODE (Input fields with cancel and update buttons) -->
              <ng-container *ngIf="editingQuestionId === question.id">
                <div style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%; gap: 10px;">
                  <div style="flex: 1;">
                    <ng-container [ngSwitch]="question.question_type">
                      
                      <!-- TEXT_SHORT & DROPDOWN - Text Input -->
                      <ng-container *ngSwitchCase="'TEXT_SHORT'">
                        <input nz-input type="text" 
                          [ngModel]="getEditedValue(question.id)" 
                          (ngModelChange)="editedAnswerValues[question.id] = $event"
                          placeholder="Enter text" />
                      </ng-container>

                      <!-- TEXT_LONG - Text Area -->
                      <ng-container *ngSwitchCase="'TEXT_LONG'">
                        <textarea nz-input 
                          [rows]="3"
                          [ngModel]="getEditedValue(question.id)" 
                          (ngModelChange)="editedAnswerValues[question.id] = $event"
                          placeholder="Enter description" ></textarea>
                      </ng-container>

                      <!-- NUMBER - Number Input -->
                      <ng-container *ngSwitchCase="'NUMBER'">
                        <input nz-input type="number" 
                          [ngModel]="getEditedValue(question.id)" 
                          (ngModelChange)="editedAnswerValues[question.id] = $event"
                          placeholder="Enter number" />
                      </ng-container>

                      <!-- CURRENCY - Number Input -->
                      <ng-container *ngSwitchCase="'CURRENCY'">
                        <input nz-input type="number" 
                          [ngModel]="getEditedValue(question.id)" 
                          (ngModelChange)="editedAnswerValues[question.id] = $event"
                          placeholder="Enter amount" />
                      </ng-container>

                      <!-- BOOLEAN_YES_NO - Checkbox -->
                      <ng-container *ngSwitchCase="'BOOLEAN_YES_NO'">
                        <label nz-checkbox 
                          [ngModel]="getEditedValue(question.id)" 
                          (ngModelChange)="editedAnswerValues[question.id] = $event">
                          Yes
                        </label>
                      </ng-container>

                      <!-- DATE - Date Picker -->
                      <ng-container *ngSwitchCase="'DATE'">
                        <input nz-input nzType="date"
                          [ngModel]="getEditedValue(question.id) | date:'yyyy-MM-dd'" 
                          (ngModelChange)="editedAnswerValues[question.id] = $event"
                          placeholder="Select date" />
                      </ng-container>

                      <!-- DROPDOWN - Select Dropdown (uses answer_text_short for value) -->
                      <ng-container *ngSwitchCase="'DROPDOWN'">
                        <nz-select [ngModel]="getEditedValue(question.id)"
                          (ngModelChange)="editedAnswerValues[question.id] = $event"
                          nzPlaceHolder="Select option">
                          <!-- Populate from question.choice_details -->
                          <nz-option *ngFor="let choice of question.choice_details" 
                            [nzValue]="choice.option_text" 
                            [nzLabel]="choice.option_text"></nz-option>
                        </nz-select>
                      </ng-container>

                      <!-- MULTIPLE_CHOICE_SINGLE (stores choice IDs in answer_selected_choice_ids) -->
                      <ng-container *ngSwitchCase="'MULTIPLE_CHOICE_SINGLE'">
                        <nz-select [ngModel]="getEditedValue(question.id)"
                          (ngModelChange)="editedAnswerValues[question.id] = $event"
                          nzPlaceHolder="Select option">
                          <nz-option *ngFor="let choice of question.choice_details" 
                            [nzValue]="choice.id" 
                            [nzLabel]="choice.option_text"></nz-option>
                        </nz-select>
                      </ng-container>

                      <!-- MULTIPLE_CHOICE_MULTI (stores array of choice IDs in answer_selected_choice_ids) -->
                      <ng-container *ngSwitchCase="'MULTIPLE_CHOICE_MULTI'">
                        <nz-select [ngModel]="getEditedValue(question.id)"
                          (ngModelChange)="editedAnswerValues[question.id] = $event"
                          nzMode="multiple"
                          nzPlaceHolder="Select options">
                          <nz-option *ngFor="let choice of question.choice_details" 
                            [nzValue]="choice.id" 
                            [nzLabel]="choice.option_text"></nz-option>
                        </nz-select>
                      </ng-container>
                    </ng-container>
                  </div>

                  <!-- NEW: CANCEL & UPDATE BUTTONS -->
                  <div style="display: flex; gap: 8px; margin-top: 5px;">
                    <button nz-button nzType="text" nzSize="small" nzDanger
                      (click)="cancelEdit(question.id)"
                      title="Cancel editing">
                      <i nz-icon nzType="close" nzTheme="outline"></i>
                    </button>
                    <button nz-button nzType="text" nzSize="small"
                      (click)="updateAnswer(question.id, question.question_type)"
                      title="Save changes">
                      <i nz-icon nzType="check" nzTheme="outline"></i>
                    </button>
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!getAnswerForQuestion(question.id)">
              <p class="not-answered">Not answered</p>
            </ng-container>
          </nz-descriptions-item>
        </nz-descriptions>
      </nz-collapse-panel>
    </nz-collapse>
  </ng-container>
</div>

<nz-divider nzText="Pricing Information" nzOrientation="center"></nz-divider>
  <nz-spin [nzSpinning]="loading" [nzTip]="loadingMsg | async">
<form nz-form [formGroup]="form" class="submissionForm" (ngSubmit)="onSubmit()">
  <div nz-row [nzGutter]="16">
    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label [nzSpan]="8" nzFor="currency_type">Currency Type</nz-form-label>
        <nz-form-control [nzSpan]="16">
          <nz-select id="currency_type" formControlName="currency">
            <nz-option *ngFor="let c of currencyTypes" [nzValue]="c.id" [nzLabel]="c.name"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  <ng-container formArrayName="product">
    <nz-table #itemTable [nzData]="itemRows.controls" [nzFrontPagination]="false" [nzShowPagination]="false" nzBordered
      [nzNoResult]="null" [nzFooter]="tableFooterTemplate">
      <thead>
        <tr>
          <th>Item/Product</th>
          <th>Cost Before Tax</th>
          <th nzWidth="200px">Tax</th>
          <th>Total Price</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody class="form-table-body">
        <tr *ngFor="let row of itemRows.controls; let i = index" [formGroupName]="i">
          <td>
            <nz-form-item nzNoColon>
              <nz-form-control>
                <input nz-input formControlName="product" placeholder="Enter item name" />
              </nz-form-control>
            </nz-form-item>
          </td>
          <td>
            <nz-form-item nzNoColon>
              <nz-form-control>
                <input nz-input type="number" formControlName="amount_before_tax" placeholder="0.00" />
              </nz-form-control>
            </nz-form-item>
          </td>
          <td>
            <nz-form-item nzNoColon>
              <nz-form-control>
                <nz-select formControlName="tax" nzMode="multiple" nzPlaceHolder="Select tax types">
                  <nz-option *ngFor="let tax of taxOptions" [nzValue]="tax.id"
                    [nzLabel]="`${tax.name} - ${tax.country_name} (${tax.rate}%)`"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </td>
          <td>
            <nz-form-item nzNoColon>
              <nz-form-control>
                <input nz-input type="number" formControlName="total_price" [readOnly]="true" />
              </nz-form-control>
            </nz-form-item>
          </td>
          <td class="text-center">
             <!-- <button nz-button nzType="default" nzSize="small" (click)="updateItemRow(i,$event)" class="remove-product-item" >
              <i nz-icon nzType="save"></i>
            </button> -->
            <button nz-button nzDanger nzSize="small" (click)="removeItemRow(i,$event)" class="remove-product-item" style="margin-left:10px">
              <i nz-icon nzType="delete"></i>
            </button>

          </td>
        </tr>
      </tbody>
    </nz-table>
  </ng-container>

  <ng-template #tableFooterTemplate>
    <div nz-row>
      <div nz-col nzSpan="18" style="text-align: right; font-weight: bold;">Total All Items:</div>
      <div nz-col nzSpan="6" style="text-align: center; font-weight: bold;">
        {{ getTotalPriceForAllItems() | currency: getCurrencySymbol() : 'symbol' : '1.2-2' }}
      </div>
    </div>
  </ng-template>

  <div nz-row [nzGutter]="16" style="margin-top:10px;">
    <div nz-col [nzSpan]="8">
      <div class="mt-3">
        <button nz-button nzType="dashed" (click)="addRow()">
          <i nz-icon nzType="plus"></i> Add Item
        </button>
      </div>
    </div>

    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label [nzSpan]="8" nzFor="exchange_rate">Exchange Rate</nz-form-label>
        <nz-form-control [nzSpan]="16">
          <nz-input-group [nzAddOnAfter]="addOnAfterTemplate">
            <input nz-input id="exchange_rate" type="number" formControlName="exchange_rate" />
          </nz-input-group>
          <ng-template #addOnAfterTemplate>
            <button nz-button nzType="text" class="converter" [disabled]="form.get('currency').value == null"
              (click)="fetchConvertion($event)">
              <nz-icon nzType="reload" [nzSpin]="loadingConversion" nzTheme="outline" />
            </button>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label [nzSpan]="8" nzFor="amount_in_usd">Amount (USD)</nz-form-label>
        <nz-form-control [nzSpan]="16">
          <input nz-input id="amount_in_usd" type="number" formControlName="usd_amount" />
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  <div nz-row [nzGutter]="16" style="margin-top:10px;">
    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label>File</nz-form-label>
        <nz-form-control [nzSpan]="16">
          <nz-upload class="w-100" [nzSize]="5120" [nzCustomRequest]="customUploadRequest" nzListType="picture"
            [nzBeforeUpload]="beforeUpload" (nzChange)="onUploadFileChange($event)" [(nzFileList)]="fileList">
            <button nz-button (click)="defaultAction($event)">
              <i nz-icon nzType="paper-clip"></i> Attach Files
            </button>
          </nz-upload>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col [nzSpan]="16" class="text-end">
      <button nz-button nzType="primary" [disabled]="form.invalid">Save</button>
    </div>
  </div>
</form>
  </nz-spin>
<nz-divider nzText="Shortlist and Finalize" nzOrientation="center"></nz-divider>

<div
  style="display: flex; justify-content: space-between; align-items: center; flex-direction: column; text-align: center;">

  <div>
    <button nz-button [nzType]="isShortlisted ? 'primary' : 'default'" (click)="markAsShortlisted()"
      [disabled]="isLoading">
      {{ isShortlisted ? 'Shortlisted' : 'Shortlist' }}
    </button>

    <button nz-button [nzType]="isFinalized ? 'primary' : 'default'" style="margin-left: 10px;"
      (click)="markAsFinalized()" [disabled]="isLoading">
      {{ isFinalized ? 'Finalized': 'Finalize' }}
    </button>
  </div>
  <p style="color: rgba(0, 0, 0, 0.65); font-size: 13px; margin-top: 10px;">
    Marking as <strong>Shortlisted</strong> will only mark this item as shortlisted.<br>
    Marking as <strong>Finalized</strong> will mark this item as finalized and unmark others (if any) from shortlisted.
  </p>
</div>
